(function() {
	'use strict';

	if (avastGlobals.detect.os.isAndroid) {
		document.querySelector('body').classList.add('mobile-detected');
	} else {
		document.querySelector('body').classList.add('desktop-detected');
	}
})();
